import { get, post } from '../lib/api';

const path = (growerId, part) => `/${growerId}/eoy-report/${part}`;

export function getReports(growerId) {
  return get(path(growerId, 'reports'));
}

export function generateReport(growerId, year, skipQc) {
  return post(path(growerId, `reports/${year}`), skipQc ? { skipQc } : {});
}
